<template>
	<div
		ref="infiniteScrollContainer"
		class="infinite-scroll-container"
	>
		<slot />
		<div
			id="scroll-trigger"
			ref="infiniteScrollTrigger"
			v-visible="!isLastPage"
		/>
	</div>
</template>

<script>
import scrollShadowMixin from '@js/mixins/scroll-shadow';

export default {
	name:   'InfiniteScroll',
	mixins: [scrollShadowMixin],
	props:  {
		isLastPage:          Boolean,
		scrollShadowEnabled: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			shadowWatcher: null,
		};
	},
	mounted() {
		this.scrollTrigger();
		if (this.scrollShadowEnabled) {
			this.shadowWatcher = this.registerShadowWatcher(this.$refs.infiniteScrollContainer, true);
			if (this.isLastPage) this.shadowWatcher.setLastPageReached(true);
		}
	},
	updated() {
		if (this.scrollShadowEnabled) {
			this.shadowWatcher.setLastPageReached(this.isLastPage);
			this.updateShadowWatchers();
		}
	},
	methods: {
		loadMore() {
			this.$emit('load-more');
		},
		scrollTrigger() {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting > 0) {
						this.loadMore();
					}
				});
			});
			observer.observe(this.$refs.infiniteScrollTrigger);
		},
	},
};
</script>

<style lang="scss" scoped>
	.infinite-scroll-container {
		overflow-y: auto;
		overflow-x: hidden;
		height: 100%;

		.is-mobile & {
			overflow-y: initial;
		}
	}

	#scroll-trigger {
		height: 1px;
	}

</style>
